import React from "react";
import "./heading.scss";

const Heading = ({ children, highlight }) => {
	return <h2 className="preHeading text">{children}</h2>;
};

export default Heading;
